import { apiGet, apiPost } from "../../utils"

export function getInstantPromotionsAdminAPI() {
    return apiGet('/api/getInstantPromotionsAdmin')
}

export function addInstantPromotionAdminAPI(data) {
    return apiPost('/api/addInstantPromotionAdmin', data)
}

export function deactivateInstantPromotionAdminAPI(data) {
    return apiPost('/api/deactivateInstantPromotionAdmin', data)
}

export function removeAndDeactivateInstantPromotionAdminAPI(data) {
    return apiPost('/api/removeAndDeactivateInstantPromotionAdmin', data)
}
